import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ErrorReportsEndpoints as Endpoints,
  type SendErrorReportRequest,
  type SendErrorReportResponse,
} from '@app/api/ErrorReports/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { ERROR_REPORTS } from '@app/constants';

export const errorReportsApi = createApi({
  reducerPath: 'errorReportsApi',
  baseQuery: createApiBaseQuery(ERROR_REPORTS),
  endpoints: ({ mutation }) => ({
    [Endpoints.Send]: mutation<SendErrorReportResponse, SendErrorReportRequest>(
      {
        query: ({ data, ...params }) => ({
          url: Endpoints.Send,
          method: Methods.POST,
          params,
          data,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
      }
    ),
  }),
});

export const { useSendMutation: useSendErrorReportMutation } = errorReportsApi;
